import { useEffect, useState } from "react";
import api from "@/lib/api";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-[#FAF7F2]">
      <Header settings={settings} />
      <main className="flex-1">{children}</main>
      <Footer settings={settings} />
    </div>
  );
}
